import { IconButton } from 'component/Button/IconButton'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { BackButton } from 'page/Header/BackButton'
import { OutfitsButton } from 'page/Header/OutfitsButton'
import { ProfileButton } from 'page/Header/ProfileButton'
import { ReactElement } from 'react'
import { me } from 'store/me'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './Header.module.scss'

const BACK = false

type Props = {
  onBack?(): void
  noBack?: boolean
}

function cell(element: ReactElement) {
  return <Space className={css.cell}>{element}</Space>
}

export const Header = observer(({ onBack, noBack }: Props) => {
  const min = opt.showMin
  const { error, screen } = store
  const user = !!me.user_id
  const outfits = store.inferences.listAll.length > 0
  const close = opt.options.close === 'close'

  const onMin = useLatestCallback(() => {
    store.state = close ? 'none' : 'min'
  })

  const isPolicy = screen === 'policy'

  return (
    <Space className={css.header}>
      {(error || isPolicy) && <Space spring />}
      {!error && !isPolicy && (
        <Space spring top>
          {BACK && !noBack && cell(<BackButton onBack={onBack} />)}
          {cell(<ProfileButton />)}
          {outfits && cell(<OutfitsButton />)}
        </Space>
      )}
      {min && (
        <Space>
          <IconButton size={48} link action={onMin}>
            <Icon name="close" size={20} />
          </IconButton>
        </Space>
      )}
    </Space>
  )
})
